/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TokenExpiryDto } from '../../models/token-expiry-dto';

export interface ApiAccountRefreshTokenGet$Params {
  'api-version'?: string;
}

export function apiAccountRefreshTokenGet(http: HttpClient, rootUrl: string, params?: ApiAccountRefreshTokenGet$Params, context?: HttpContext): Observable<StrictHttpResponse<TokenExpiryDto>> {
  const rb = new RequestBuilder(rootUrl, apiAccountRefreshTokenGet.PATH, 'get');
  if (params) {
    rb.query('api-version', params['api-version'], {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TokenExpiryDto>;
    })
  );
}

apiAccountRefreshTokenGet.PATH = '/api/account/refresh-token';
